<template>
  <PageWrap>
    <HeadSeo :data="data?.page" />
    <HeaderOther :h1="data?.page.h1" />
    <main>
      <UiBreadCrumbs
        :data="[
          {
            title: data?.page.title,
          },
        ]"
      />

      <section v-if="list">
        <div class="pd70">
          <div class="wrapper w1000">
            <ul id="news_list">
              <li :key="i" v-for="(n, i) in list">
                <NuxtLink :to="`/news/${n.url}-${n.id}`">
                  <UiAnim type="lr-100" class="image" v-if="n.preview_image">
                    <UiLazyImg
                      :src="`/upload/image/${n.preview_image}/news.jpg`"
                    />
                  </UiAnim>
                  <UiAnim type="rl-100" class="text" :delay="1">
                    <h3 class="transition">{{ n.title }}</h3>
                    <p class="pubdate" v-if="n.pub_date">
                      <time :datetime="n.pub_date.substring(0, 10)" pubdate>{{
                        formatDate(n.pub_date)
                      }}</time>
                    </p>
                    <p class="preview_text" v-if="n.preview_text">
                      {{ n.preview_text }}
                    </p>
                  </UiAnim>
                </NuxtLink>
              </li>
            </ul>
            <span class="clr"></span>

            <div class="pagenav" v-if="params.totalPages > 1">
              <template v-if="params.page > 1">
                <a href="/news" @click.prevent="goto(1)" class="to-first"
                  ><IconArrowRight
                /></a>
                <a
                  :href="`/news${
                    data.news.params.page > 2 ? `?page=${params.page - 1}` : ''
                  }`"
                  @click.prevent="goto(params.page - 1)"
                  >Предыдущая</a
                >
              </template>

              <a
                v-for="i in prevs"
                :key="i"
                :href="`/news?page=${i}`"
                @click.prevent="goto(i)"
                >{{ i }}</a
              >

              <span class="current">{{ params.page }}</span>

              <template v-for="i in 5" :key="i">
                <a
                  v-if="params.page + i <= params.totalPages"
                  :href="`/news?page=${params.page + i}`"
                  @click.prevent="goto(params.page + i)"
                  >{{ params.page + i }}</a
                >
              </template>

              <template v-if="params.page < params.totalPages">
                <a
                  :href="`/news?page=${params.page + 1}`"
                  @click.prevent="goto(params.page + 1)"
                  >Следующая</a
                >
                <a
                  :href="`/news?page=${params.totalPages}`"
                  @click.prevent="goto(params.totalPages)"
                  ><IconArrowRight
                /></a>
              </template>
              <span class="clr"></span>
            </div>
          </div>
        </div>
      </section>
      <BlockArticleText :html="data?.page.text" :name="`page-${data?.page?.id}`" />
      <BlockWhyWe />
      <BlockContact />
    </main>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
import { useWindowScroll } from "@vueuse/core";
const { y } = useWindowScroll();
const route = useRoute();
const list = ref();
const params = ref();
const err = ref();
import { formatDate } from "~/helpers/format";
const { data, error } = await useFetch(
  `/api/news?page=${route.query.page || 1}&content=true`
);
list.value = data.value.news.list;
params.value = data.value.news.params;
err.value = data.value.news.error;

const prevs = computed(() => {
  if (!params.value || params.value.page == 1) return [];
  const links = [];
  for (let i = 5; i >= 1; i--) {
    if (params.value.page - i > 0) links.push(params.value.page - i);
  }
  return links;
});

const goto = async (page) => {
  y.value = 0;
  await navigateTo(`/news${page != 1 ? `?page=${page}` : ""}`);
};

const getList = async (p) => {
  if (p == params.value.page) return;
  const res = await $fetch(`/api/news?page=${p}&content=false`);
  list.value = res.list;
  params.value = res.params;
  err.value = res.error;
};

watch(route, async (n) => {
  await getList(n.query.page || 1);
});

if (error.value || err.value) {
  const event = useRequestEvent();
  setResponseStatus(event, 404, "Page Not Found");
}
</script>
